import React, { useState, useEffect } from "react";
import { useAuth, API } from "../lib/api";
import axios from "axios";
import { Ship, LogIn, Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [hero, setHero] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/hero`).then((r) => setHero(r.data?.url)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username.trim().toLowerCase(), password.trim());
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  const backend = process.env.REACT_APP_BACKEND_URL;
  const fallback = "https://images.pexels.com/photos/17233512/pexels-photo-17233512.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";
  const heroUrl = hero ? `${backend}${hero}` : fallback;

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4 py-10 relative bg-center bg-cover"
      style={{
        backgroundImage: `linear-gradient(rgba(11,19,43,0.55), rgba(11,19,43,0.65)), url('${heroUrl}')`,
      }}
    >
      <div className="tk-card w-full max-w-md p-7 tk-rise" data-testid="login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ backgroundColor: "hsl(var(--surface-2))" }}>
            <Ship className="w-6 h-6" style={{ color: "hsl(var(--primary))" }} />
          </div>
          <div>
            <h1 className="text-2xl font-display font-semibold leading-tight">Mavi Yolculuk '26</h1>
            <p className="text-sm" style={{ color: "hsl(var(--text-2))" }}>Seyahat Paneli</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="tk-label">Kullanıcı Adı</label>
            <input
              data-testid="login-username-input"
              className="tk-input"
              placeholder="ismet"
              name="username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
            />
          </div>
          <div>
            <label className="tk-label">Şifre</label>
            <div className="relative">
              <input
                data-testid="login-password-input"
                className="tk-input pr-10"
                type={showPwd ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                data-testid="login-password-toggle"
                onClick={() => setShowPwd((v) => !v)}
                aria-label={showPwd ? "Şifreyi gizle" : "Şifreyi göster"}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md"
                style={{ color: "hsl(var(--text-2))" }}
              >
                {showPwd ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          {err && (
            <div data-testid="login-error" className="text-sm rounded-lg px-3 py-2" style={{ backgroundColor: "#FDECEA", color: "#9B2F28" }}>
              {err}
            </div>
          )}
          <button
            data-testid="login-submit-btn"
            disabled={loading}
            className="tk-btn w-full flex items-center justify-center gap-2 disabled:opacity-60"
          >
            <LogIn className="w-4 h-4" /> {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
          <p className="text-xs text-center" style={{ color: "hsl(var(--text-2))" }}>
            İlk giriş şifreniz: <span className="font-semibold">2026</span>
          </p>
        </form>
      </div>
    </div>
  );
}
